import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isTokenExpired, getTokenExpiryMs } from "../utils/tokenUtils";
import { logoutActionInitiate } from "../redux/actions/auth/logoutAction";
import { showToast } from "../utils/styles/toastUtils";

/**
 * Automatically logs out the user when their JWT token expires.
 *
 * - On mount: if the token is already expired → immediate logout
 * - While active: sets a timer to logout exactly when the token expires
 */
export function useTokenExpiry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const doLogout = () => {
      showToast.error("Session expired. Please log in again.");
      dispatch(logoutActionInitiate(navigate));
    };

    // Token already expired when the app loads
    if (isTokenExpired(token)) {
      doLogout();
      return;
    }

    // Schedule auto-logout exactly when the token expires
    const msUntilExpiry = getTokenExpiryMs(token);
    if (msUntilExpiry !== null && msUntilExpiry > 0) {
      timerRef.current = setTimeout(doLogout, msUntilExpiry);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dispatch, navigate]);
}
